import { TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';

/**
 * Búsqueda global (también acepta lecturas de pistola: el lector "teclea" y envía Intro).
 * Código de palet, referencia del cliente, cliente, mercancía o ubicación.
 */
export function GlobalSearch() {
  const [value, setValue] = useState('');
  const navigate = useNavigate();

  const submit = () => {
    const q = value.trim();
    if (!q) return;
    void navigate(`/buscar?q=${encodeURIComponent(q)}`);
    setValue('');
  };

  return (
    <TextInput
      style={{ flex: 1, maxWidth: 480 }}
      size="sm"
      placeholder="Buscar palet, referencia, cliente, ubicación…"
      leftSection={<IconSearch size={18} />}
      value={value}
      onChange={(event) => setValue(event.currentTarget.value)}
      onKeyDown={(event) => {
        if (event.key === 'Enter') submit();
      }}
      aria-label="Búsqueda global"
    />
  );
}
